import { createFileRoute } from '@tanstack/react-router';
import { HomeVlPage } from '@/domains/retail';

// Home del Portal Admin VentasLuga — el tablero del piso.
export const Route = createFileRoute('/_backoffice/retail-admin/')({
    component: HomeVlPage,
});
